import React from 'react'
import { connect } from 'react-redux'
import Col from 'muicss/lib/react/col'
import PrizeList from './PrizeList'
import { loadPrizes } from '../../../actions'

class Prizes extends React.Component {

  componentDidMount = () =>
    this.props.loadPrizes()

  render = () => (
    <Col>
      <Col md="12">
        <PrizeList />
      </Col>
    </Col>
    )
}

const mapStateToProps = state => ({
  ...state.user.global_prizes.prize_selected,
})

const mapDispatchToProps = dispatch => ({
  loadPrizes: () => dispatch(loadPrizes()),
})

export default connect(mapStateToProps, mapDispatchToProps)(Prizes)



// WEBPACK FOOTER //
// ./src/components/Main/Prizes/index.jsx